import { BACKGROUND_IMAGE_DESKTOP, BACKGROUND_IMAGE_MOBILE } from '../elements/assets'
import { LOGO_GARDEN_CONTENT } from './logoGarden'

export const HERO_WITH_FORM = `
...on heroWithForm_Entry {
  id
  typeHandle
  anchorId

  backgroundColor

  ${ BACKGROUND_IMAGE_DESKTOP }
  ${ BACKGROUND_IMAGE_MOBILE }
  
  heading {
    html
  }
  description
  textTable {
    text
  }

  bottomText

  ${ LOGO_GARDEN_CONTENT }

  formSettings {
    ... on formSettings_ContentBlock {
      heading
      description: text
      formId
      redirectLocation {
        url
      }
      withBorder
      onlyBusinessEmail
      errorValidateBusinessEmail
    }
  }
}
`